import { IDConsigneeLookupLayout, IDCustomerLookupLayout, IDShipperLookupLayout } from "../../common/lookups/Layouts/IdLayouts"

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "TransactionNumberFrom",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction # From",
                "type": "text",
                filterType: 'rangeFrom',
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerFrom",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer Name From",
                "type": "lookup",
                filterType: 'rangeFrom',
                layout: IDCustomerLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "TransactionNumberTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction # To",
                "type": "text",
                filterType: 'rangeTo',
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer Name To",
                "type": "lookup",
                filterType: 'rangeTo',
                layout: IDCustomerLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "TransactionDateFrom",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Date From",
                "type": "date",
                filterType: 'rangeFrom',
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "ConsigneeFrom",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Name From",
                "type": "lookup",
                filterType: 'rangeFrom',
                layout: IDConsigneeLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "TransactionDateTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Date To",
                "type": "date",
                filterType: 'rangeTo',
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "ConsigneeTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Name To",
                "type": "lookup",
                filterType: 'rangeTo',
                layout: IDConsigneeLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperFrom",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Name From",
                "type": "lookup",
                filterType: 'rangeFrom',
                layout: IDShipperLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Name To",
                "type": "lookup",
                filterType: 'rangeTo',
                layout: IDShipperLookupLayout({ valueExpr: 'identityid', displayExpr: 'identityid' }),
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


            {
                "name": "Pallets",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pallets",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Stage",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StageFlag",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Stage Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Actualreceivedshippeddatetime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Actual Received Shipped Datetime",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Carrier",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Carrier",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Carrier Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Companyid",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Company Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Consignee",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeAddress1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Address1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeAddress2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Address2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeAddressMemo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Address Memo",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeState",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee State",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeZip",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee Zip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Container",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Container",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Customer",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Equipmentinterchangereport",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Equipment Interchange Report",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Freightchargetype",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Freight Charge Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Shipper",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperAddress1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Address1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperAddress2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Address2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperAddressMemo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Address Memo",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperState",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper State",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Shipperbolnumber",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Bol Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipperZip",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper Zip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Reference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Recordtype",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Record Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TotalQuantityActual",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Total Quantity Actual",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TotalQuantityOrder",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Total Quantity Order",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Transactiondate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Transactiongroup",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Group",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "Transactiontype",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Type",
                "type": "select",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransportCarrier",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transport Carrier",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransportCarrierName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transport Carrier Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Code10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcomment",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date1",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date2",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date3",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date4",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date5",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date6",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date7",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date8",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date9",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Date10",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity1",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity2",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity3",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity4",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity5",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity6",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity7",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity8",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity9",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Quantity10",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "User Defined Reference10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Rowid",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Row Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Sublotcount",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Sublot Count",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TotalGrossWeight",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Total Gross Weight",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TotalNetWeight",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Total Net Weight",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Plannedreceivedshippeddatetime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Planned Received Shipped Datetime",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RCustomer",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Customer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "IsAssociatedCustomerTrans",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Is Associated Customer Trans",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationUserId",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Creation User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateUserId",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Last Update User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Module",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Module",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransportationMode",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transportation Mode",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TruckReference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Truck Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TruckArrivalDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Truck Arrival Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TruckDepartDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Truck Depart Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DeliveryPickupFlag",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery Pickup Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DeliveryPickupDepartDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery Pickup Depart Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DispatchOrderNumber",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dispatch Order Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ThirdPartyBillType",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Third Party Bill Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsolidateInvoiceFlag",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consolidate Invoice Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PickStatus",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FreightAmount",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Freight Amount",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CodAmount",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Cod Amount",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CodAmountCollected",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Cod Amount Collected",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CodCollectionDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Cod Collection Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CodPayMethod",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Cod Pay Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TaxBasis",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Tax Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TaxRate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Tax Rate",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TaxAmount",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Tax Amount",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintReceipt",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Print Receipt",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintBol",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Print Bol",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintLabel",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Print Label",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SendFax",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Send Fax",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FiscalYear",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fiscal Year",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FiscalPeriod",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fiscal Period",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CommitDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Commit Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "HoldReason",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Hold Reason",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsolidatedInvoice",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consolidated Invoice",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransferToDispatch",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transfer To Dispatch",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RCodPayor",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RCod Payor",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RCodPayee",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RCod Payee",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RFreightBillTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RFreight Bill To",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RArOpenItemHeader",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RAr Open Item Header",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RStagingWarehouse",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RStaging Warehouse",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RStagingArea",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RStaging Area",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RTaxCode",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RTax Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RThirdPartyCustomer",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RThird Party Customer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RThirdPartyFreightBillTo",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RThird Party Freight Bill To",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RFreightBillNumber",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RFreight Bill Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RAgent",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Agent",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RCarrier",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Carrier",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RDriver",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Driver",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RConsignee",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Consignee",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RShipper",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Shipper",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RProfile",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "R Profile",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FmTruckReference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fm Truck Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FmTrailerRReference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fm Trailer RReference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FmDriverReference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fm Driver Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransportationYardLeaveDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transportation Yard Leave Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DeliveryPickupPlannedDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery Pickup Planned Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DeliveryPickupArrivedDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery Pickup Arrived Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PlanResourcesCode",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Resources Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PlanResourcesHours",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Resources Hours",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PlanReference",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PlanComment",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StagingStartDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging Start Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StagingEndDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging End Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnloadPickByPlanDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload Pick By Plan Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CheckByPlanDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By Plan Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PutAwayByPlanDate",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By Plan Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EditTransmitCustomer",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Edit Transmit Customer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EditTransmitShipper",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Edit Transmit Shipper",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EditTransmitConsignee",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Edit Transmit Consignee",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EditTransmitCarrier",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Edit Transmit Carrier",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EquipmentType",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Equipment Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

        ]
    }
]
export {
    SearchLayout
}